module.exports = __webpack_public_path__ + "static/img/12.b8d7a8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/12.png
// module id = t0bv
// module chunks = 0